import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaInstagram, FaLinkedin } from 'react-icons/fa';
import logoImg from '../assets/logo.png'; // Logo görselinin yolu
import './Landing.css';

function Landing() {
    const navigate = useNavigate();

    return (
        <div className="landing-page">
            <section className="landing-hero">
                <div className="landing-hero__glyphs" aria-hidden="true">
                    <span>&lt;/&gt;</span>
                    <span>&lt;/&gt;</span>
                </div>

                <div className="landing-hero__inner">
                    {/* Yuvarlak Logo Alanı */}
                    <div className="landing-hero__logo-wrapper">
                        <img src={logoImg} alt="Ege Forum Logo" className="landing-hero__logo" />
                    </div>

                    <div className="landing-hero__content">
                        <h1>Ege Bilgisayar Mühendisliği Forumu</h1>
                        <p>
                            Ders sorularından kod problemlerine, staj tavsiyelerinden serbest sohbete —
                            topluluğumuzun bilgi paylaştığı, birbirine yardım ettiği ortak alan.
                        </p>
                        <div className="landing-hero__actions">
                            <button className="landing-btn landing-btn--primary" onClick={() => navigate('/register')}>
                                Üye Ol
                            </button>
                            <button className="landing-btn landing-btn--secondary" onClick={() => navigate('/login')}>
                                Giriş Yap
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <section className="landing-features">
                <div className="landing-feature-card">
                    <span className="landing-feature-icon">❓</span>
                    <h3>Soru & Tartışma</h3>
                    <p>Ders, ödev ya da aklına takılan her şeyi sor, topluluktan gerçek cevaplar al.</p>
                </div>
                <div className="landing-feature-card">
                    <span className="landing-feature-icon">{'</>'}</span>
                    <h3>Kod Paylaşım</h3>
                    <p>Kod parçanı paylaş, syntax-highlight'lı görünümle sorununu net anlat.</p>
                </div>
                <div className="landing-feature-card">
                    <span className="landing-feature-icon">💬</span>
                    <h3>Serbest Sohbet</h3>
                    <p>Staj, kariyer, ders seçimi ya da sadece muhabbet — kendi kürsün seni bekliyor.</p>
                </div>
            </section>

            <section className="landing-about">
                <h2>Hakkımızda</h2>
                <p>
                    Bu platform, Ege Üniversitesi Bilgisayar Mühendisliği öğrencileri tarafından,
                    öğrenciler için geliştirildi. Amacımız, ders ve kariyer sürecinde birbirimize
                    daha kolay ulaşabileceğimiz, bilgiyi paylaşabileceğimiz bir alan oluşturmak.
                </p>
                <div className="landing-social">
                    <span>Bizi takip et:</span>
                    <a href="https://www.instagram.com/egebilmuhtoplulugu/" target="_blank" rel="noreferrer">
                        <FaInstagram /> Instagram
                    </a>
                    <a href="https://www.linkedin.com/company/ege-%C3%BCniversitesi-bilgisayar-m%C3%BChendisli%C4%9Fi-toplulu%C4%9Fu/" target="_blank" rel="noreferrer">
                        <FaLinkedin /> LinkedIn
                    </a>
                </div>
            </section>
        </div>
    );
}

export default Landing;